module.exports = __webpack_public_path__ + "img/illo_menu_send.e3a78ea3.png";